import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";

// https://webmaster.blogs.uva.es/2018/04/16/controla-los-gestos-tactiles-con-javascript-vanilla-a-pelo/
// Inicialize the variables
let touchStartX = 0;
let touchStartY = 0;
let touchEndX = 0;
let touchEndY = 0;

export default class FullScreenConstroller {
  constructor({ main, opts }) {
    this._ = main;
    this.map = opts.map;
    this.setOptions(opts);
    this.isInFullScreenMode = false;
    // this.createTargetButton = true;
    this.buttons = {};

    this.sizes = {
      origin: {
        width: this.canvas.style.width,
        height: this.canvas.style.height,
      },
    };
    const { isDesktop } = this._.sizes;
    const mapSettings = this._.settings.get("mapSettings");
    this.center = isDesktop
      ? mapSettings.center.desktop
      : mapSettings.center.mobile;

    this.defaultZoom = isDesktop
      ? mapSettings.zoom.desktop
      : mapSettings.zoom.mobile;

    this.clickLayer.addEventListener(
      "touchstart",
      this.touchStart.bind(this),
      true
    );
    this.clickLayer.addEventListener(
      "touchend",
      this.touchEnd.bind(this),
      true
    );

    this.map.addControl(this, "top-left");

    if (this.createTargetButton === true) {
      this.map.on("zoomend", (e) => {
        if (parseInt(this.map.getZoom()) == this.map.getMinZoom()) {
          this.buttons.targetButton.classList.remove("zoom-in");
          this.buttons.targetButton.classList.add("zoom-out");
        } else {
          this.buttons.targetButton.classList.remove("zoom-out");
          this.buttons.targetButton.classList.add("zoom-in");
        }
      });
    }
  }

  touchStart(e) {
    if (this.isInFullScreenMode === false) {
      touchStartX = e.changedTouches[0].screenX;
      touchStartY = e.changedTouches[0].screenY;
    }
  }

  touchEnd(e) {
    if (this.isInFullScreenMode === false) {
      touchEndX = e.changedTouches[0].screenX;
      touchEndY = e.changedTouches[0].screenY;

      if ((touchEndY == touchStartY) & (touchEndX == touchStartX)) {
        this.enterFullScreen.call(this, null);
      }
    }
  }

  enterFullScreen(show, e) {
    if (this.isInFullScreenMode == false) {
      const ratio = Math.min(window.devicePixelRatio, 2);
      disableBodyScroll(document.body);
      this.canvas.setAttribute("width", `${innerWidth * ratio}`);
      this.canvas.setAttribute("height", `${innerHeight * ratio}`);
      this.canvas.style.position = `absolute`;
      this.canvas.style.width = `${innerWidth}px`;
      this.canvas.style.height = `${innerHeight}px`;
      this._.el.classList.add("g-fullscreen");
      if (this.createTargetButton === true) {
        this.buttons.targetButton.classList.add("zoom-in");
      }

      this.map.resize();

      setTimeout(() => {
        this._.map.events.addRemoveMapEvents({ add: true });
        return this.map.zoomIn({
          duration: 1000,
        });
      }, 150);

      this.isInFullScreenMode = true;
    }
  }

  exitFullScreen() {
    enableBodyScroll(document.body);
    const ratio = Math.min(window.devicePixelRatio, 2);
    this.canvas.setAttribute("width", null);
    this.canvas.setAttribute("height", null);
    this.canvas.style.width = `${this.sizes.origin.width * ratio}px`;
    this.canvas.style.height = `${this.sizes.origin.height * ratio}px`;
    this._.el.classList.remove("g-fullscreen");
    if (this.createTargetButton === true) {
      this.buttons.targetButton.classList.remove("zoom-in");
    }

    this._.map.tooltip.mouseleave();
    this._.map.tooltip.tweenHeight(false);
    this.map.resize();

    setTimeout(() => {
      this._.map.events.addRemoveMapEvents({ remove: true });
      return this.map.zoomTo(this.defaultZoom, {
        duration: 750,
      });
    }, 10);
    this.isInFullScreenMode = false;
    this._.map.events.mouseleave();
  }

  onRemove() {}
  onAdd() {
    const container = document.createElement("div");
    const exitButton = this.createExitButton.call(this);
    container.appendChild(exitButton);

    if (this.createTargetButton === true) {
      const targetButton = this.createButtonTarget.call(this);
      container.appendChild(targetButton);
    }
    return container;
  }

  createExitButton() {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.classList.add("mapboxgl-ctrl-x", "mapboxgl-ctrl-icon");
    btn.setAttribute("title", "Salir del modo pantalla completa");
    btn.setAttribute("aria-label", "Salir del modo pantalla completa");
    btn.onclick = this.exitFullScreen.bind(this, false);

    const container = document.createElement("div");
    container.className =
      "mapboxgl-ctrl mapboxgl-ctrl-fullscreen mapboxgl-ctrl-group ";
    container.appendChild(btn);
    this.buttons.exitButton = container;

    return container;
  }

  createButtonTarget() {
    const btn = document.createElement("button");
    const span = document.createElement("span");
    btn.type = "button";
    span.classList.add("mapboxgl-ctrl-icon", "mapbox-gl-andalucia");
    btn.setAttribute("title", "Salir del modo pantalla completa");
    btn.setAttribute("aria-label", "Salir del modo pantalla completa");
    btn.appendChild(span);

    btn.onclick = this.map.zoomTo.bind(this.map, this.defaultZoom, {
      duration: 10,
      center: this.center,
    });

    const container = document.createElement("div");
    container.className =
      "mapboxgl-ctrl mapboxgl-ctrl-cyl mapboxgl-ctrl-group ";
    container.appendChild(btn);
    this.buttons.targetButton = container;

    return container;
  }

  setOptions(opts) {
    Object.keys(opts).forEach((opt) => {
      this[opt] = opts[opt];
    }, this);
  }
}
